import { render, staticRenderFns } from "./itemLogsLineChart.vue?vue&type=template&id=28a021a2&scoped=true"
import script from "./itemLogsLineChart.vue?vue&type=script&lang=js"
export * from "./itemLogsLineChart.vue?vue&type=script&lang=js"
import style0 from "./itemLogsLineChart.vue?vue&type=style&index=0&id=28a021a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a021a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a021a2')) {
      api.createRecord('28a021a2', component.options)
    } else {
      api.reload('28a021a2', component.options)
    }
    module.hot.accept("./itemLogsLineChart.vue?vue&type=template&id=28a021a2&scoped=true", function () {
      api.rerender('28a021a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/itemLogsLineChart.vue"
export default component.exports